import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns['bs']);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/bs.js';


import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import 'lightgallery/modules/lg-fullscreen.js';

import lozad from 'lozad';

import './js/components/gallery';
import './js/globals';
import './js/list';
import './js/details';
import './js/booking';
import './js/contact';
import './js/inquiry';
import './js/bookingAddGuests.js';
//import './js/contactRequest.js';


window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();


window.scroll_fade = lozad('.scroll-fade-top', {
    rootMargin: '20px 0px',
    loaded: el => {
        $(el).addClass('start-animation');
    }
});
window.scroll_fade.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/api.js?render=" + '6Ld8rFYsAAAAAMCsIWEBlxlNmP5u0kidstY5bUth');
    }
});
window.nobserver.observe();